import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aeb5f0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-item" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-copyright" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "CC BY 4.0", -1))
const _hoisted_4 = { class: "dialog-footer" }

import { ref, shallowRef, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import MapTabs from '@/components/maps/MapTabs.vue';
import LegendDrawer from '@/components/LegendDrawer.vue';
import ExportView from '@/components/ExportView.vue';

import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenu',
  setup(__props) {

const store = useStore();
const state = store.state;
const drawerVisible = computed(() => state.sidebarStore.drawerVisible);

const { t } = useI18n();

const { track } = useTrack();

const activeName = ref();
const activeModule = shallowRef();
const drawerComponent = ref();
const isModalVisible = ref(false);

const handleDrawerClose = () => {
  store.commit('sidebarStore/setDrawerVisible', false);
};

const menuItems = computed(() => [
  {
    key: t('navigation.left.map'),
    name: t('navigation.left.map'),
    icon: 'icon-icon_ditu',
    handler: () => {
      store.commit('sidebarStore/setDrawerVisible', true);
      activeName.value = t('Drawer.Layers.title');
      activeModule.value = MapTabs;

      track(FunctionIdEnum.globalLayer_nav_showLayers, EventTypeEnum.CLICK);
    },
  },
  {
    key: t('legend'),
    name: t('legend'),
    icon: 'icon-Legends1',
    handler: () => {
      store.commit('sidebarStore/setDrawerVisible', true);
      activeName.value = t('legend');
      activeModule.value = LegendDrawer;
      track(FunctionIdEnum.globalLayer_nav_showLegends, EventTypeEnum.CLICK);
    },
  },
  {
    key: t('navigation.left.export'),
    name: t('navigation.left.export'),
    icon: 'icon-a-icon_daochuyemian',
    handler: () => {
      store.commit('sidebarStore/setDrawerVisible', true);
      activeName.value = t('navigation.left.export');
      activeModule.value = ExportView;
      setTimeout(() => {
        drawerComponent.value.initExportMap();
        drawerComponent.value.initMiniMap();
      }, 100);
      track(FunctionIdEnum.globalLayer_nav_showExport, EventTypeEnum.CLICK);
    },
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createBlock(_component_el_aside, {
    class: _normalizeClass({
      'expand-aside':
        activeName.value !== _unref(t)('navigation.left.export') && drawerVisible.value,
    })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu, { class: "menu" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (menu) => {
            return (_openBlock(), _createBlock(_component_el_menu_item, {
              key: menu.key,
              onClick: menu.handler,
              index: menu.key
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["iconfont", menu.icon])
                  }, null, 2),
                  _createVNode(_component_el_text, { class: "menu-text" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(menu.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 2
            }, 1032, ["onClick", "index"]))
          }), 128)),
          _createVNode(_component_el_button, {
            type: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isModalVisible.value = true)),
            class: "icon-copyright-menu"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_dialog, {
            modelValue: isModalVisible.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isModalVisible).value = $event)),
            "destroy-on-close": true,
            "append-to-body": true,
            width: 500
          }, {
            header: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('copyright.title')), 1)
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isModalVisible.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('copyright.confirm')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_drawer, {
        direction: "ltr",
        "modal-class": {
        'export-drawer sidemenu-drawer':
          activeName.value === _unref(t)('navigation.left.export'),
        'normal-drawer sidemenu-drawer':
          activeName.value !== _unref(t)('navigation.left.export'),
      },
        modelValue: drawerVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drawerVisible).value = $event)),
        onClose: handleDrawerClose,
        modal: false,
        size: "100%",
        "close-on-press-escape": false,
        "append-to-body": true,
        "destroy-on-close": true
      }, {
        header: _withCtx(() => [
          _createVNode(_component_el_text, {
            size: "large",
            class: "header"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(activeName.value), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(activeModule.value), {
            ref_key: "drawerComponent",
            ref: drawerComponent
          }, null, 512))
        ]),
        _: 1
      }, 8, ["modal-class", "modelValue"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})